module.exports = __webpack_public_path__ + "static/img/jz1-1.993e091.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jz1-1.png
// module id = 746
// module chunks = 0